export default function () {
    $(document).ready(function () {
        filterListingCategory();
        filterListingPage();

        function filterListingCategory()
        {
            $('.listing-filter').on('click', function (e) {
                e.preventDefault();
                let url = $(this).attr('href');
                let filterButton = $(this);

                $('.listing-filter').each(function () {
                  $(this).removeClass('current-filter').attr('aria-current', false);
                });

                filterButton.addClass('current-filter').attr('aria-current', true);

                $.ajax(url)
                    .done(function (response) {
                        $('#listing-grid').html(response);
                        filterListingPage();
                        $('.grid').each(function () {
                            applyIsotope($(this));
                        });

                        let alertSection = $('#alert-section');
                        alertSection.show();
                        alertSection.append('<p>' + filterButton.attr('data-title') + ' - Active Filter. ' + $('#listing-grid').find('.grid-item').length + ' results.</p>');

                        setTimeout(function () {
                            alertSection.children().remove();
                            alertSection.hide();
                        }, 5000);
                    });
            });
        }

        function filterListingPage()
        {
            $('.listing-page-num').on('click', function (e) {
                e.preventDefault();
                let url = $(this).attr('href');

                if (url.includes("/listings") == false) {
                    url = url.replace('?', '/listings/all?')
                }

                $.ajax(url)
                    .done(function (response) {
                        $('#listing-grid').html(response);
                        filterListingPage();
                        $('.grid').each(function () {
                            applyIsotope($(this));
                        });
                    })
            });
        }

        function applyIsotope(grid)
        {
            if (grid) {
                grid.isotope({
                    itemSelector: '.grid-item',
                    percentPosition: true,
                    masonry: {
                        columnWidth: '.grid-sizer',
                        horizontalOrder: true
                    }
                  });
            }
        }
    });
}



// WEBPACK FOOTER //
// ./themes/app/src/js/listing-filter.js